import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Card } from "react-bootstrap";
import ImagePreviewModal from "../../components/imageView/ImagePreviewModal";

const VisitorsView = () => {
  const [formlist, setFormList] = useState<any>(null);
  const location = useLocation();
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const rawData = queryParams.get("histoty_data");
    if (rawData) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(rawData));
        setFormList(parsedData);
      } catch (error) {
        console.error("Error parsing EmployeeData:", error);
      }
    }
  }, [location.search]);
  const [locationName, setLocationName] = useState<string>("");
  const { lat, lon } =
    JSON.parse(formlist?.allDetails?.geo_location || "{}") || {};

  useEffect(() => {
    if (formlist?.allDetails?.geo_location) {
      fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`
      )
        .then((response) => response?.json())
        .then((data) => {
          if (data.display_name) {
            setLocationName(data?.display_name);
          } else {
            setLocationName("Location not found");
          }
        })
        .catch((error) => {
          console.error("Error fetching location:", error);
          setLocationName("Error fetching location");
        });
    }
  }, [formlist?.allDetails?.geo_location]);

  const openMap = (lat: any, lon: any) => {
    const url = `https://www.google.com/maps?q=${lat},${lon}`;
    window.open(url, "_blank");
  };

  const fields = [
    {
      label: "Full Name",
      value: formlist?.allDetails?.name,
      icon: "fa-user",
      colSize: "col-md-6",
    },
    {
      label: "Mobile Number",
      value: formlist?.allDetails?.email,
      icon: "fa-envelope",
      colSize: "col-md-6",
    },
    {
      label: "Description",
      value:
        (formlist?.allDetails?.description?.length || 0) > 100
          ? formlist?.allDetails?.description.slice(0, 100) + "..."
          : formlist?.allDetails?.description,
      fullValue: formlist?.allDetails?.description,
      showMore: (formlist?.allDetails?.description?.length || 0) > 50,
      icon: "fa-building",
      colSize: "col-md-12",
    },
    { label: "latitude", value: lat, icon: "fa-building", colSize: "col-md-6" },
    { label: "longitude", value: lon, icon: "fa-user", colSize: "col-md-6" },

    {
      label: "Address location",
      value: locationName,
      icon: "fa-user",
      colSize: "col-md-12",
    },
    {
      label: "Status",
      value: formlist?.allDetails?.status,
      icon: "fa-phone",
      colSize: "col-md-6",
    },
  ];

  const handleImageClick = (imgUrl: string) => {
    setSelectedImage(imgUrl);
    setShowImageModal(true);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {formlist && (
            <Card className="max-w-xl mx-auto shadow-md border rounded-xl overflow-hidden">
              <div className="card shadow-sm rounded-3 border-0">
                <div className="card-header bg-primary text-white py-3">
                  <h2 className="mb-0 text-center text-white">Visit View</h2>
                </div>
                <div className="card-body p-4">
                  <div className="row g-4">
                    {fields.map((field, index) => (
                      <div key={index} className={field.colSize}>
                        <p className="info">
                          <span className="info-label">
                            <i className={`fas ${field.icon}`}></i> {field.label} :
                          </span>
                          <span className="info-value">
                            {field.value || "N/A"}
                            {field.showMore && (
                              <button
                                onClick={() => setShowDescriptionModal(true)}
                                style={{
                                  border: "1px solid #00ff00",
                                  background: "linear-gradient(135deg, rgb(58 181 75 / 100%), rgb(84 218 212))",
                                  color: "#fff",
                                  cursor: "pointer",
                                  paddingLeft: "5px",
                                  marginLeft: 20
                                }}
                              >
                                Read more
                              </button>
                            )}
                          </span>
                        </p>
                      </div>
                    ))}
                    <div className="mb-3 col-6">
                      <p className="info">
                        <label
                          htmlFor="googleMap"
                          className="form-label d-flex align-items-center "
                        >
                          <span style={{ marginRight: 25 }}>Google Map</span>
                          <i
                            className="fa fa-map-marker-alt text-primary"
                            style={{ cursor: "pointer", fontSize: "1.8rem" }}
                            onClick={() => openMap(lat, lon)}
                            title="Open in Google Maps"
                          ></i>
                        </label>
                      </p>
                    </div>
                    <div className="mb-3 col-6">
                      <p className="info" style={{ width: 125 }}>
                        <img
                          src={formlist?.allDetails?.image?.replace(
                            /^"|"$/g,
                            ""
                          )}
                          alt="Visitor"
                          style={{
                            cursor: "pointer",
                            maxWidth: "100px",
                            borderRadius: "8px",
                          }}
                          onClick={() =>
                            handleImageClick(
                              formlist?.allDetails?.image?.replace(/^"|"$/g, "")
                            )
                          }
                        />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          )}
        </div>
      </div>
      <ImagePreviewModal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        imageUrl={selectedImage}
      />
      {formlist?.allDetails?.description && (
        <ImagePreviewModal
          show={showDescriptionModal}
          onHide={() => setShowDescriptionModal(false)}
          title="Full Description"
          body={
            <div style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
              {formlist.allDetails.description}
            </div>
          }
        />
      )}
    </>
  );
};

export default VisitorsView;
